<template>
  <div>
    <div class="back" v-if="isVisible" @click="hideModal"></div>
    <div class="serviceView" v-if="isVisible">
      <div class="modalView_pop">
        <div class="modalView_pop_l">
          <div class="modalView_pop_l_view">
            <div class="modalView_pop_l_view_t">
              <div class="modalView_pop_l_view_t_1">
                <div class="modalView_pop_l_view_t_3_text">{{ $t('myPlanI18n.title') }}</div>
              </div>
              <div class="modalView_pop_l_view_t_2">{{ $t('myPlanI18n.desc') }}</div>
            </div>

            <div class="plan-list-scroll" v-loading="loading" >
              <div v-if="!loading && planList.length === 0" class="plan-empty">
                {{ $t('myPlanI18n.empty') }}
              </div>
              <div
                v-for="item in planList"
                :key="item.id"
                class="plan-item"
              >
                <div
                  class="plan-item-head"
                  role="button"
                  tabindex="0"
                  @click="toggleExpand(item.id)"
                >
                  <span class="plan-item-title">{{ item.title }}</span>
                  <i class="el-icon-arrow-right" v-if="!isExpanded(item.id)" />
                  <i class="el-icon-arrow-down" v-else />
                </div>
                <div v-show="isExpanded(item.id)" class="plan-item-expanded">
                  <div
                    class="plan-item-body message-content"
                    v-html="renderPlanContent(item)"
                  />
                  <div
                    v-if="item.conversation_id"
                    class="plan-item-actions"
                  >
                    <el-button
                      type="primary"
                      size="small"
                      plain
                      @click.stop="openConversationDetail(item)"
                    >
                      {{ $t('myPlanI18n.conversationDetail') }}
                    </el-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getPlanList } from '@/api/index';
import { formatChatMessage } from '@/utils/formatChatMarkdown';
import { mapState } from "vuex";
export default {
  components: {
  },
  data() {
    return {
      isVisible: false, // 控制弹窗的显示状态
      loading: false, // 加载状态
      planList: [], // 方案列表
      expandedIds: [], // 展开的方案ID列表
    }
  },
  methods: {
    // 判断方案是否展开
    isExpanded(id) {
      return this.expandedIds.includes(id);
    },
    // 切换方案展开状态
    toggleExpand(id) {
      const i = this.expandedIds.indexOf(id);
      if (i >= 0) {
        this.expandedIds.splice(i, 1);
      } else {
        this.expandedIds.push(id);
      }
    },
    // 获取方案内容文本
    getPlanContentText(item) {
      if (!item || item.content == null) return '';
      if (typeof item.content === 'string') return item.content;
      return item.content.content != null ? String(item.content.content) : '';
    },
    // 渲染方案内容（与 ChatPage.formatMessage 一致）
    renderPlanContent(item) {
      const raw = this.getPlanContentText(item);
      return formatChatMessage(raw);
    },
    // 获取方案列表
    async fetchPlanList() {
      this.loading = true;
      try {
        const res = await getPlanList({ page_no: 1, page_size: 100 });
        const body = res && res.data;
        this.planList = Array.isArray(body && body.data) ? body.data : [];
      } catch (e) {
        this.planList = [];
        const msg = this.$t('myPlanI18n.loadError');
        this.$message.error(msg);
      } finally {
        this.loading = false;
      }
    },
    // 显示弹窗
    showModal() {
      this.isVisible = true;
      this.expandedIds = [];
      this.fetchPlanList();
    },
    // 隐藏弹窗
    hideModal() {
      this.isVisible = false;
    },
    // 跳转碳知会话详情（由 Sidebar 处理路由与侧栏列表锁定）
    openConversationDetail(item) {
      if (!item || !item.conversation_id) return;
      this.$emit('open-plan-conversation', {
        conversationId: item.conversation_id,
        accessType: 'tz',
      });
    },
  },
  computed: {
    ...mapState(["userInfo"]), // 获取用户信息
  },
};
</script>

<style scoped lang="scss">
.back {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: rgba(33, 33, 33, 0.5);
  height: 100vh;
  z-index: 999;
}

.serviceView {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
  background: var(--global-background);
  width: 1200px;
  height: 650px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-around;
  z-index: 1001;

  .modalView_pop {
    width: calc(100% - 20px);
    height: calc(100% - 20px);
    background-color: #ffffff;
    /* 设置不透明的白色底色 */
    background-image: var(--global-inner-background);
    /* 渐变叠加在白色底色上 */
    border-radius: 20px;
    display: flex;

    .modalView_pop_l {
      width: 1100px;
      height: 100%;
      position: relative;

        .modalView_pop_l_view {
          width: 100%;
          height: 100%;
          margin: 0 10px 0 35px;
          border-left: 2px dashed #E3E6E8;
          border-right: 2px dashed #E3E6E8;
          display: flex;
          flex-direction: column;
          min-height: 0;

        .modalView_pop_l_view_t {
          flex-shrink: 0;
          width: 100%;
          border-bottom: 2px dashed #E3E6E8;
          height: 140px;
          display: flex;
          flex-direction: column;
          justify-content: center;


          .modalView_pop_l_view_t_1 {
            width: auto;
            height: 46px;
            margin-left: 33px;

            .modalView_pop_l_view_t_3_text {
              font-size: 35px;
              color: rgba(33, 33, 33, 1);
              font-weight: 500;
            }
          }

          .modalView_pop_l_view_t_2 {
            font-size: 18px;
            color: rgba(0, 0, 0, 1);
            font-weight: 500;
            margin-left: 35px;
            letter-spacing: 3px;
          }
        }

        .plan-list-scroll {
          width: 100%;
          height: 100%;
          flex: 1;
          min-height: 0;
          overflow: auto;
          scrollbar-width: none;
          padding: 12px;
        }

        .plan-empty {
          text-align: center;
          color: rgba(0, 0, 0, 0.45);
          font-size: 15px;
          padding: 48px 0;
        }

        .plan-item {
          background: #ffffff;
          border: 1px solid transparent;
          border-radius: 10px;
          margin-bottom: 10px;
          padding: 10px;
          &:hover {
            border: 1px solid #18a1f6;
          }
        }

        .plan-item-head {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 14px;
          cursor: pointer;
        }

        .plan-item-title {
          font-size: 16px;
          font-weight: 500;
          color: rgba(33, 33, 33, 0.92);
          line-height: 1.5;
        }

        .plan-item-body {
          width: 100%;
          max-height: 280px;
          padding: 0 12px 16px 22px;
          font-size: 14px;
          line-height: 1.65;
          color: rgba(0, 0, 0, 0.78);
          overflow: auto;
          scrollbar-width: none;
        }

        .plan-item-actions {
          display: flex;
          justify-content: flex-end;
          padding: 12px;
        }
      }
    }
  }
}
</style>